export const QUERY_PARAMS_FILTERS = {
  DRAFT: "draft",
  ON_GOING: "on-going",
  PENDING_REVIEW: "pending-review",
  FINISHED: "finished",
  ARCHIVED: "archived"
};

export const STATUS_FILTER = "status-filter";
